import styled from '@emotion/styled'

export const ColumnWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  row-gap: ${(props: any) => props.gap || 24}px;

  ${(props: any) => props.stylecolumn}
`
